import React, { Component } from 'react';
import {
  isDirty,
  isPristine,
  isValid,
  isSubmitting,
  submit,
  change,
  reset,
} from 'redux-form';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { withStyles } from '@material-ui/core';
import classNames from 'classnames';
import Link from '@material-ui/core/Link';
import LoadingIcon from 'mdi-react/LoadingIcon';
import Dropzone from 'react-dropzone';
import NotificationSystem from 'rc-notification';
import { NOTIFICATION_NODE_STYLE } from 'constants/misc';
import BasicNotification from 'components/Notification';
import {
  saveContactsCSV,
  importCurrentContacts,
  resetContacts,
  setPreviewContactsParams,
  createContactsBulk,
  createContact,
} from 'redux/actions/contactActions';
import { CSV_CONTACT_LIMIT, getContactLimitError, READER_ERROR } from 'constants/config';
import { CSV_HELP_ARTICLE } from 'constants/routing';
import { HEADERS_SECTION } from 'constants/contact';
import { uniqBy, get } from 'lodash';
import { csvReader } from 'utils/misc';
import { DuplicateHeaderError } from 'utils/error';
import {
  transformContactsCSVObject,
  transformContactsCustomField,
  getMappingFromFormData,
} from 'utils/contact';
import { ReactComponent as UploadIcon } from 'icons/upload.svg';
import { ReactComponent as PersonMailIcon } from 'icons/personMail.svg';
import { ReactComponent as DraftIcon } from 'icons/draft.svg';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Stepper from 'components/Stepper';
import StepConnector from 'components/Stepper/StepConnector';
import CSVrowToObjSelector from 'selectors/CSVrowToObjSelector';
import headerSelector from 'selectors/headerSelector';
import ErrorNotificationDialog from '../ErrorNotificationDialog';
import ContactsTemplatePage from './ContactsTemplatePage';
import ContactCreate from './ContactCreate';
import SequenceBuilderActions from './SequenceBuilderActions';
import ExistingContactImportForm from './ExistingContactImportForm';


const ADD_CONTACT_STEPS = {
  DROPZONE: 0,
  MAP_FIELDS: 1,
};
const ADD_CONTACT_STEPPER_STEPS = [
  { label: 'Upload CSV', value: 0 },
  { label: 'Map Fields', value: 1 },
];

const TABS = {
  IMPORT_CSV: 'importCsv',
  REPLY_STATUS: 'replyStatus',
  MANUAL_CONTACTS: 'manualContacts',
};

const styles = theme => ({
  accordion: {
    boxSizing: 'border-box',
    borderRadius: '6px',
    boxShadow: 'none',
    border: `1px solid ${theme.palette.secondary[300]}`,
    marginBottom: '1rem',
    '&.opened': {
      backgroundColor: theme.palette.secondary[50],
    },
    '&:before': {
      content: 'unset',
    },
  },
  accordionSummary: {
    display: 'flex',
    alignItems: 'center',
  },
  accordionTitle: {
    fontSize: '0.875rem',
    fontWeight: '600',
    lineHeight: '170%',
    color: theme.palette.secondary.text,
    letterSpacing: '-0.2px',
  },
  accordionSubtitle: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '146%',
    letterSpacing: '-0.01em',
    color: theme.palette.primary.text,
  },
  accordionTitleAvatar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    width: '2rem',
    height: '2rem',
    borderRadius: '4px',
    backgroundColor: theme.palette.primary[100],
    marginRight: '1rem',
  },
});

class ContactsStartPage extends Component {
  static propTypes = {
    setStep: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    onSkip: PropTypes.func.isRequired,
    onNext: PropTypes.func.isRequired,
    toggleModal: PropTypes.func.isRequired,
    submit: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    createContactsBulk: PropTypes.func.isRequired,
    saveContactsCSV: PropTypes.func.isRequired,
    resetContacts: PropTypes.func.isRequired,
    importCurrentContacts: PropTypes.func.isRequired,
    setPreviewContactsParams: PropTypes.func.isRequired,
    contactsCSV: PropTypes.shape({}).isRequired,
    contacts: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
      account: PropTypes.number,
      sequence: PropTypes.number,
    }).isRequired,
    sequence: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
      account_id: PropTypes.number,
      organization: PropTypes.number,
    }).isRequired,
    submitting: PropTypes.bool,
    pristine: PropTypes.bool,
    replyStatusFieldIsDirty: PropTypes.bool.isRequired,
    opportunityStageFieldIsDirty: PropTypes.bool.isRequired,
    csv: PropTypes.shape({
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
    }).isRequired,
    handleChangeModalSize: PropTypes.func,
    createContact: PropTypes.func.isRequired,
    sequenceBuilder: PropTypes.bool,
    classes: PropTypes.shape({}).isRequired,
  };

  static defaultProps = {
    submitting: false,
    pristine: true,
    sequenceBuilder: false,
    handleChangeModalSize: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      openedTab: null,
      isErrorAlertOpen: false,
      errorMessage: null,
      activeContactStep: ADD_CONTACT_STEPS.DROPZONE,
    };
    this.setAddContactStep = this.setAddContactStep.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onNext = this.onNext.bind(this);
  }

  componentDidMount() {
    // eslint-disable-next-line no-return-assign
    NotificationSystem.newInstance({ style: { zIndex: '9999' } }, n => this.notification = n);
    this.props.saveContactsCSV([]);
    this.props.resetContacts();
    this.props.handleChangeModalSize('large');
  }

  componentWillUnmount() {
    this.notification.destroy();
  }

  onCSVLoad = (result) => {
    if (result.length > CSV_CONTACT_LIMIT) {
      this.showErrorAlert(getContactLimitError(result.length));
    } else {
      try {
        const data = {
          headers: headerSelector(result),
          contacts: CSVrowToObjSelector(result),
        };
        this.props.saveContactsCSV(data);
        this.setAddContactStep(ADD_CONTACT_STEPS.MAP_FIELDS);
      } catch (err) {
        const message = (
          <div>
            {err instanceof DuplicateHeaderError ?
              `Your file has duplicate column "${err.message}", ` :
              'Your file is not in the correct format, '}
            please update your file and try again. See tips&nbsp;
            <Link
              target="_blank"
              rel="noreferrer"
              href={CSV_HELP_ARTICLE}
            >
              here
            </Link>.
          </div>
        );
        this.showErrorAlert(message);
      }
    }
  }

  onCSVError = () => {
    this.showErrorAlert(READER_ERROR);
  }

  onDrop = async (acceptedFiles) => {
    if (acceptedFiles.length === 0) {
      this.showErrorAlert('This is not CSV file.');
    } else if (acceptedFiles.length && !acceptedFiles[0].size) {
      this.showErrorAlert(`The selected CSV is empty, CSV must contain headers
        as the first rows and values in subsequent rows`);
    } else if (acceptedFiles.length) {
      csvReader(this.onCSVLoad, this.onCSVError, acceptedFiles[0]);
    }
  }

  async onNext() {
    await this.processSubmit(true);
  }

  async onSave() {
    await this.processSubmit(false);
    await this.props.toggleModal();
  }

  setAddContactStep(step) {
    this.setState({ activeContactStep: step });
  }

  getDisabled() {
    const {
      replyStatusFieldIsDirty,
      opportunityStageFieldIsDirty,
      disableSaveTemplateForm,
      disableContactCreate,
    } = this.props;
    const { openedTab } = this.state;
    if (openedTab === TABS.IMPORT_CSV) {
      return disableSaveTemplateForm;
    } else if (openedTab === TABS.REPLY_STATUS) {
      return !replyStatusFieldIsDirty && !opportunityStageFieldIsDirty;
    } else if (openedTab === TABS.MANUAL_CONTACTS) {
      return disableContactCreate;
    }
    return true;
  }

  async processSubmit(next) {
    const { openedTab } = this.state;
    if (openedTab === TABS.IMPORT_CSV) {
      await this.props.change('sequenceImportTemplateForm', 'next', next);
      await this.props.submit('sequenceImportTemplateForm');
    } else if (openedTab === TABS.REPLY_STATUS) {
      await this.props.change('ExistingContactImportForm', 'next', next);
      await this.props.submit('ExistingContactImportForm');
    } else if (openedTab === TABS.MANUAL_CONTACTS) {
      await this.props.change('ContactCreate', 'next', next);
      await this.props.submit('ContactCreate');
    }
  }

  toggleErrorAlert = () => this.setState({ isErrorAlertOpen: !this.state.isErrorAlertOpen });

  toggleTab(e, tab) {
    e.preventDefault(); // to prevent form from firing
    if (this.state.openedTab === tab) {
      this.setState({ openedTab: null });
    } else {
      this.setState({ openedTab: tab });
    }
  }

  showNotification = (color, message) => {
    this.notification.notice({
      content: <BasicNotification
        color={color}
        message={message}
      />,
      duration: 5,
      closable: false,
      style: NOTIFICATION_NODE_STYLE,
      className: 'alert--colored right-up',
    });
  }

  showErrorAlert = (message) => {
    this.setState({
      isErrorAlertOpen: true,
      errorMessage: message,
    });
  }

  processContactsImportSubmit = async (formData) => {
    const { contactsCSV, sequence } = this.props;
    // Format contacts
    const mapping = getMappingFromFormData(formData[HEADERS_SECTION]);

    // Create contacts
    const mappedContacts = uniqBy(
      transformContactsCSVObject(contactsCSV, mapping),
      contact => contact.email && contact.email.toLowerCase(),
    );
    const mappedContactsWithOrganizationId = mappedContacts.map(el => ({ ...el, organization: sequence.organization }));
    transformContactsCustomField(mappedContactsWithOrganizationId);

    await this.props.createContactsBulk(mappedContactsWithOrganizationId, { sequence_id: sequence.id });

    const params = {
      sequence: sequence.id,
      contacts: get(this.props.contacts, 'results', []).map(({ email, outlets }) => (
        { email, outlet: outlets.id }
      )),
      reply_statuses: formData.replyStatusField && formData.replyStatusField.map(l => (l.value)),
      reply_filter_type: formData.replyRadio,
      opportunity_stages: formData.opportunityStageField && formData.opportunityStageField.map(l => (l.value)),
      opportunity_filter_type: formData.stageRadio,
    };

    await this.props.setPreviewContactsParams(params);
    this.showNotification('success', 'CSV file imported!');
    if (formData.next) {
      this.props.onNext();
    }
  }

  processExistingContactImportSubmit = async (formData) => {
    this.showNotification('warning', 'Please wait, importing contacts');
    const params = {
      sequence: this.props.sequence.id,
      reply_statuses: formData.replyStatusField && formData.replyStatusField.map(l => (l.value)),
      reply_filter_type: formData.replyRadio,
      opportunity_stages: formData.opportunityStageField && formData.opportunityStageField.map(l => (l.value)),
      opportunity_filter_type: formData.stageRadio,
      account: this.props.sequence.account_id,
    };
    await this.props.setPreviewContactsParams(params);
    await this.props.importCurrentContacts(params);
    if (formData.next) {
      this.props.onNext();
    }
  }

  async processContactCreateSubmit(formData) {
    const contact = {
      organization: this.props.sequence.organization,
      ...formData,
    };
    transformContactsCustomField([contact]);
    await this.props.createContact(contact, { sequence_id: this.props.sequence.id });
    this.showNotification('success', 'Contact created successfully.');
    if (formData.addNext) {
      this.props.reset('ContactCreate');
    } else {
      await this.props.setPreviewContactsParams({
        sequence: this.props.sequence.id,
        reply_statuses: [],
        contacts: get(this.props.contacts, 'results', []).map(({ email, outlet }) => (
          { email, outlet: outlet.id }
        )),
        reply_filter_type: 'include',
        opportunity_stages: [],
        opportunity_filter_type: formData.stageRadio,
        account: this.props.sequence.account_id,
      });
      if (formData.next) {
        this.props.onNext();
      }
    }
  }

  render() {
    const {
      onSkip,
      csv,
      contacts,
      sequenceBuilder,
      toggleModal,
      classes,
    } = this.props;
    const {
      openedTab,
      isErrorAlertOpen,
      errorMessage,
      activeContactStep,
    } = this.state;
    const isCSVUploading = csv.loading;
    const isContactsloading = contacts.loading;

    return (
      <>
        {(isCSVUploading || isContactsloading) && <div className="loader"><LoadingIcon /></div>}
        <ErrorNotificationDialog
          isOpen={isErrorAlertOpen}
          toggle={this.toggleErrorAlert}
          title="Import Error"
          errorMessage={errorMessage}
        />

        <Accordion
          className={classNames(classes.accordion, { opened: openedTab === TABS.IMPORT_CSV })}
          expanded={openedTab === TABS.IMPORT_CSV}
          onChange={e => this.toggleTab(e, TABS.IMPORT_CSV)}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className={classes.accordionSummary}>
              <div className={classes.accordionTitleAvatar}><UploadIcon /></div>
              <div>
                <div className={classes.accordionTitle}>Import from csv</div>
                {openedTab === TABS.IMPORT_CSV &&
                  <div className={classes.accordionSubtitle}>
                    Upload contacts from a CSV and map fields
                  </div>}
              </div>
            </div>
          </AccordionSummary>
          <AccordionDetails onClick={e => e.stopPropagation()} className="centered-and-flexed pb-3">
            <Row className="w-75">
              <Col sm={12}>
                <Stepper
                  connector={<StepConnector variant="dashed" />}
                  className="shadow-none pt-0 bg-transparent"
                  activeStep={activeContactStep}
                  steps={ADD_CONTACT_STEPPER_STEPS}
                />
              </Col>
            </Row>
            <Row className="w-100">
              <Col sm={12}>
                {activeContactStep === ADD_CONTACT_STEPS.DROPZONE &&
                  <Dropzone disabled={isCSVUploading} onDrop={this.onDrop} accept=".csv,text/csv">
                    {({
                      getRootProps, getInputProps, isDragActive, isDragAccept,
                    }) => (
                      <div
                        {...getRootProps()}
                        className={classNames('upload', { 'upload--active': isDragActive })}
                      >
                        <input {...getInputProps()} />

                        <div className="uploading-text">
                          <span
                            className={classNames('lnr', {
                              'lnr-hourglass': isCSVUploading,
                              'lnr-upload': !isCSVUploading,
                            })}
                          />
                          {isCSVUploading ? (
                            <span className="loading-dots"> Uploading CSV</span>
                          ) : (
                            ` ${isDragAccept ? 'Drop' : 'Upload'} CSV`
                          )}
                        </div>

                      </div>
                    )}
                  </Dropzone>
                }
                {activeContactStep === ADD_CONTACT_STEPS.MAP_FIELDS &&
                  <ContactsTemplatePage
                    onSubmit={data => this.processContactsImportSubmit(data)}
                  />
                }
              </Col>
            </Row>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className={classNames(classes.accordion, { opened: openedTab === TABS.REPLY_STATUS })}
          expanded={openedTab === TABS.REPLY_STATUS}
          onClick={e => this.toggleTab(e, TABS.REPLY_STATUS)}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className={classes.accordionSummary}>
              <div className={classes.accordionTitleAvatar}><PersonMailIcon /></div>
              <div>
                <div className={classes.accordionTitle}>Add from existing current contacts</div>
              </div>
            </div>
          </AccordionSummary>
          <AccordionDetails className="flex-column pb-3" onClick={e => e.stopPropagation()}>
            <ExistingContactImportForm
              onSubmit={data => this.processExistingContactImportSubmit(data)}
            />
          </AccordionDetails>
        </Accordion>
        <Accordion
          className={classNames(classes.accordion, { opened: openedTab === TABS.MANUAL_CONTACTS })}
          expanded={openedTab === TABS.MANUAL_CONTACTS}
          onChange={e => this.toggleTab(e, TABS.MANUAL_CONTACTS)}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className={classes.accordionSummary}>
              <div className={classes.accordionTitleAvatar}><DraftIcon /></div>
              <div><div className={classes.accordionTitle}>Add manual contact</div></div>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <div className="w-100">
              <ContactCreate onSubmit={formData => this.processContactCreateSubmit(formData)} />
            </div>
          </AccordionDetails>
        </Accordion>

        {sequenceBuilder ?
          <SequenceBuilderActions
            onSkip={onSkip}
            onSave={this.onSave}
            onNext={this.onNext}
            disabledSave
            disabledNext={this.getDisabled()}
          /> :
          <SequenceBuilderActions
            onBack={toggleModal}
            onNext={this.onNext}
            disabledSave={this.getDisabled()}
          />
        }
      </>
    );
  }
}


export default compose(
  withStyles(styles),
  connect(
    state => ({
      csv: state.csv,
      contacts: state.contacts,
      contactsCSV: state.contactsCSV.contacts,
      sequence: state.sequence,
      replyStatusFieldIsDirty: isDirty('ExistingContactImportForm')(state, ['replyStatusField']),
      opportunityStageFieldIsDirty: isDirty('ExistingContactImportForm')(state, ['opportunityStageField']),
      disableSaveTemplateForm: isPristine('sequenceImportTemplateForm')(state) ||
        isSubmitting('sequenceImportTemplateForm')(state),
      disableContactCreate: !isValid('ContactCreate')(state) || isSubmitting('ContactCreate')(state),
    }),
    {
      saveContactsCSV,
      importCurrentContacts,
      resetContacts,
      setPreviewContactsParams,
      createContactsBulk,
      createContact,
      submit,
      change,
      reset,
    },
  ),
)(ContactsStartPage);
